import { useState, useEffect } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import useNavigate from "hooks/Navigate";
import { useDispatch, useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import reduxApis from "../redux/apis";
import { Header } from "components";
import { useTranslation } from "react-i18next";
import utils from "utils";

const AdminLogin = () => {
  const [formData, setFormData] = useState({ email: "", password: "" });

  const { adminUser, loading } = useSelector((store) => store.admin);
  const [loginBtn, setLoginBtn] = useState(false);
  const { t } = useTranslation();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const onChangeHandler = (e) => {
    const { id, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [id]: value }));
  };

  useEffect(() => {
    if (adminUser?.type) {
      navigate(utils.getAdminHomeRoute(adminUser?.type));
    }
  }, [adminUser]);

  const onSubmitHandler = async (e) => {
    e.preventDefault();
    try {
      setLoginBtn(true);
      const res = await dispatch(reduxApis.adminLogin(formData));
      setLoginBtn(false);
      if (res?.payload) {
        const adminType = res?.payload?.data?.user?.type;
        navigate(utils.getAdminHomeRoute(adminType));
      }
    } catch (error) {
      setLoginBtn(false);
      const message = error?.response?.data?.message || error?.message || "Unable to log in";
      toast.error(message);
    }
  };

  return (
    <div className="landing-main New-login-form-main">
      {/* <Sidebar/> */}
      <div className="landing-page landing-main-page custom-scroll">
        <Header />
        <Container>
          {/* <Row>
                       
                        <Col>
                            <h3 className="section-title dark-text ">{t("titles.login_admin")}</h3>

                        </Col>
                    </Row> */}

          {/* <Form onSubmit={onSubmitHandler}>
                        <Row>
                            <Col md={4}/>

                            <Col md={4}>

                                <Form.Group className="mb-3" controlId="email">
                                    <Form.Control
                                        type="email"
                                        placeholder={t("placeholders.email")}
                                        onChange={onChangeHandler}
                                        value={formData.email}
                                        required
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="password">
                                    <Form.Control
                                        type="password"
                                        placeholder={t("placeholders.password")}
                                        onChange={onChangeHandler}
                                        value={formData.password}
                                        required
                                    />
                                </Form.Group>

                                <Button
                                    variant="outline-danger"
                                    className="w-100 mb-5"
                                    type="submit"
                                    disabled={loginBtn}
                                >
                                    {t("buttons.login")}

                                </Button>
                            </Col>
                        </Row>
                    </Form> */}

          <Row className="justify-content-center">
            <Col md={8} lg={5}>
              <div className="New-login-form-form p-5">
                <div className="New-login-form-inside">
                  <div className="Centre-the-content">
                    <p className="New-login-form-heading-2 pb-5">
                      {t("titles.login_admin")}
                    </p>
                  </div>
                  <div>
                    <Form onSubmit={onSubmitHandler}>
                      <Form.Group className="mb-3" controlId="email">
                        <Form.Control
                          type="email"
                          placeholder={t("placeholders.email")}
                          onChange={onChangeHandler}
                          value={formData.email}
                          required
                        />
                      </Form.Group>

                      <Form.Group className="mb-3" controlId="password">
                        <Form.Control
                          type="password"
                          placeholder={t("placeholders.password")}
                          onChange={onChangeHandler}
                          value={formData.password}
                          required
                        />
                      </Form.Group>
                      <div className="Login-btn-container pb-3">
                        <button type="submit" disabled={loading}>
                          {loading
                            ? t("buttons.logging_in")
                            : t("buttons.login")}
                        </button>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default AdminLogin;
